
    <div class="map-viewer"> 
      <div hidden id="slider1"></div>
      <div class="cesium-map" style="width:100%;height:100%;"></div>
    </div>